<template>
  <v-row density="compact">
    <p>ADX assesses the strength of a trend in stock prices.</p>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.term"
        :items="['5', '15']"
        label="ADX Number of Days"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('term', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12">
      <v-text-field
        :model-value="rule.config.threshold"
        density="compact"
        hide-details
        variant="outlined"
        label="ADX Threshold"
        @update:model-value="updateConfig('threshold', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12">
      <v-select
        :model-value="rule.config.above_below"
        :items="['above', 'below']"
        label="ADX above or below threshold"
        hint="ADX above or below threshold"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('above_below', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      editedTa: {
        enabled: true,
        above_below: 'above',
        term: '5',
        rule_type: 'adx',
        consecutive_days: 5,
        threshold: 20,
        long_short: 'long'
      },
      defaultTa: {
        enabled: true,
        above_below: 'above',
        term: '5',
        rule_type: 'adx',
        consecutive_days: 5,
        threshold: 20,
        long_short: 'long'
      }
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  mounted() {
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != 'adx') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultTa) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
